<script setup lang="ts">
import { type Version } from '~/models/version'

useTitle('download.title', { t: true })
useDescription('Download PingZapper')

const apiClient = useAPIClient()
const { gtag } = useAnalytics()
const { region } = useRegion()

const { versions } = await apiClient.versions()  

const latest = computed(() => {
  const result:{ stable?: Version, beta?: Version } = {}

  if (!versions.value?.length) {
    return result
  }

  result.stable = versions.value.find(v => v.channel === 'stable')
  result.beta = versions.value.find(v => v.channel === 'beta')

  return result
})
</script>

<template>
  <div class="download page">
    <page-header :heading="$t('download.title')" />
    <img src="/images/logo_color.png" width="128" />


    <div class="download">
      <h2>PingZapper 3</h2>

      <div v-if="latest.stable" class="version">
        <NuxtLink
          @click="gtag('event', 'download_stable')"
          :href="latest.stable.downloadLink"
          target="_blank"
          class="button icon-text"
        >
          <Icon name="download" color="white" size="18px" />
          {{ $t('download.title') }}
        </NuxtLink>

        <p>
          {{ $t('download.version') }}
          {{ latest.stable?.version }}
          ({{ latest.stable?.versionDate.toISODate() }})
        </p>
        <p>{{ $t('download.os_compatibility') }}</p>
      </div>

      <div v-if="latest.beta" class="version">
        <hr>

        <h3>Beta</h3>

        <NuxtLink
          @click="gtag('event', 'download_beta')"
          :href="latest.beta.downloadLink"
          target="_blank"
          class="button icon-text"
        >
          <Icon name="download" color="white" size="18px" />
          {{ $t('download.title') }}
        </NuxtLink>

        <p>
          {{ $t('download.version') }}
          {{ latest.beta?.version }}
          ({{ latest.beta?.versionDate.toISODate() }})
        </p>
      </div>
    </div>

    <!-- <div v-if="region !== 'china'" class="v2">
      <hr>
      <h2>PingZapper 2</h2>
      <p>({{ $t('download.legacy') }})</p>

      <NuxtLink
        @click="gtag('event', 'download_legacy')"
        href="https://cdn.pingzapper.com/downloads/PingZapper_2.1.3_installer.zip"
        target="_blank"
        class="button icon-text"
      >
        <Icon name="download" color="white" size="18px" />
        {{ $t('download.title') }}
      </NuxtLink>

      <p>Version 2.1.3 (2017-08-07)</p>
      <p>Windows 7-10</p>
    </div> -->
  </div>
</template>

<style scoped lang="scss">
hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.download {
  text-align: center;

  & > h2 {
    font-size: 2rem;
  }
}

.download { margin-top: 2rem; }

.v2 {
  margin-top: 2rem;
  color: $color-medium-gray;

  .button {
    background-color: $color-medium-gray;
  }
}
</style>
